import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { ActivitiesBarComponent } from "../../../shared/components/activities-bar/activities-bar.component";
import {
  Column,
  convertStatus,
  CustomTableComponent,
  getStatusColor,
} from "../../../shared/elements/customTable.component";
import { PagerComponent } from "../../../shared/elements/pager.component";
import { Typography } from "@mui/material";
import { UserDto } from "../dto/index.dto";
import { useGetHosters } from "../hooks/hosters.hook";
import { HosterDetailsComponent } from "./hoster-details.component";
import { useEventsStore } from "../../../shared/stores/events.store";

export interface HostersProps {
  // Define any props needed for the hosters component
}
const columns: Column[] = [
  {
    key: "responsable",
    label: "Responsable",
    render: (_, row) => (
      <>
        <Typography fontWeight="600" fontSize="0.85rem">
          {row.firstName} {row.lastName}
        </Typography>
        <Typography fontSize="0.75rem" color="gray">
          {row.email}
        </Typography>
      </>
    ),
  },
  { key: "organisation", label: "Organisation" },
  { key: "phone", label: "Num de téléphone" },
  { key: "region", label: "Région" },
  {
    key: "status",
    label: "Status",
    render: (value) => (
      <Typography fontWeight="bold" sx={{ color: getStatusColor(value) }}>
        {convertStatus(value)}
      </Typography>
    ),
  },
];
export const HostersComponent: React.FC<HostersProps> = () => {
  const [selectedHosterId, setSelectedHosterId] = useState<string | null>(
    null
  );
  const [page, setPage] = useState(1);

  const { event } = useEventsStore();
  const { data, isLoading, error } = useGetHosters(event, page);

  useEffect(() => {
    setPage(1);
  }, [event]);

  const handleHosterClick = (row: UserDto) => {
    setSelectedHosterId(row.id.toString());
  };

  const handleBack = () => {
    setSelectedHosterId(null);
  };

  if (isLoading) {
    return <div>Loading hosters...</div>;
  }

  if (error) {
    return <div>Error loading hosters</div>;
  }

  // If a hoster is selected, show the details view
  if (selectedHosterId) {
    return (
      <HosterDetailsComponent id={selectedHosterId} onBack={handleBack} />
    );
  }

  // Otherwise show the list view
  return (
    <Box p={1.5}>
      <ActivitiesBarComponent />
      <Box mt={1.5}>
        <CustomTableComponent
          columns={columns}
          rows={data?.data || []}
          handleClick={handleHosterClick}
        />
        {data && (
          <PagerComponent
            page={data.page}
            totalPages={data.totalPages}
            total={data.total}
            onPageChange={setPage}
          />
        )}
      </Box>
    </Box>
  );
};
